import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import { Row } from '@vds/grids';
import { TrailingTooltip } from '@vds/tooltips';
import { Notification } from '@vds/notifications';
import PropTypes from 'prop-types';

import VdsRadioButton from '../../../../../common/RadioButton/index';
import Checkbox from '../../../../../common/CheckBox/index';
import { isMobile, viewport } from '../../../../../common/Helpers';

import { FontWrapper } from '../styledWrapper';
import { getLqAddress } from '../../../../../common/addressUtils';
import { ButtonWrapper, ModalButtonContainer } from './HomePhone.styles';

const ToolTipWrapper = styled.div`
  ${({ styles }) => styles}
`;

const AddressConfirmationModal = (props) => {
  console.log('AddressConfirmationModal => re-renders');
  const type = viewport();
  const { closeModal, onClickContinue, landline } = props;

  const [selectedAddressOption, setSelectedAddressOption] = useState(props.selectedAddressOption);
  const [noE911EligibleError, setNoE911EligibleError] = useState(false);
  const [enableContinueButton, setEnableContinueButton] = useState(props.addressSelected);

  const lqAddress = getLqAddress();

  useEffect(() => {
    window.addEventListener('focusin', update);
  });

  const update = () => {
    //  for accessibility fix focusing on model close
    if (document.activeElement.name === 'addressSelection') {
      if (lqAddress) {
        if (
          !enableContinueButton &&
          !noE911EligibleError &&
          document.activeElement.value === lqAddress.fullAddress &&
          selectedAddressOption === undefined
        ) {
          document.activeElement.addEventListener('keydown', (e) => checkTabPress(e, lqAddress.fullAddress));
        }
      }
    }
  };

  const checkTabPress = (e, element) => {
    //  for accessibility fix focusing on model close
    if ((e.key === 'Tab' || e.keyCode === 9) && !enableContinueButton && !noE911EligibleError && selectedAddressOption !== element) {
      document.getElementById('close-button').focus();
    }
  };

  const onChangeHandler = (e) => {
    setSelectedAddressOption(e.target.value);
    setNoE911EligibleError(e.target.value === "I don't see my home address");
    setEnableContinueButton(false);
  };

  const onNpanxxHandler = () => {
    if (lqAddress) {
      const postData = {
        state: lqAddress.state,
        city: lqAddress.city,
        zipcode: lqAddress.zipCode,
        mdnCountRequired: false,
        sortTypeDesc: false,
      };

      props.propsList.callNPANXXOnHp(postData);
    }
  };

  const onchangeCheckBox = (e) => {
    console.log('onchangeCheckBox => ');
    if (e.target.checked) {
      props.onAddress({ selectedAddressOption });
      onNpanxxHandler();
    }

    props.onAddressSelected(e.target.checked);

    setEnableContinueButton(e.target.checked);
  };

  const emergencyAddress = lqAddress.fullAddress;
  const addressArray = [emergencyAddress, landline && landline.home_address_not_available].map((item, idx) => ({
    name: 'addressSelection',
    children: item,
    value: item,
    id: `addressSelection_${idx}`,
  }));
  let selectedAddress = selectedAddressOption;
  if (selectedAddress) {
    selectedAddress = addressArray?.[0] ? addressArray[0]?.value : null;
  }
  let buttonClasses = 'marginTop80';
  if (isMobile()) {
    if (noE911EligibleError) {
      buttonClasses = 'width100 marginTop30';
    } else {
      buttonClasses = 'width100 marginTop100';
    }
  } else if (noE911EligibleError) {
    buttonClasses = 'marginTop40';
  }

  return (
    <React.Fragment>
      {emergencyAddress && (
        <div>
          <FontWrapper
            primitive="h3"
            styles={`font-weight: 400; ${
              isMobile() ? 'margin-top: 41px; font-size:20px; line-height: 24px' : 'margin-top: 48px; font-size: 24px; line-height: 28px;'
            }`}
          >
            {landline?.address_confirmation_heading}
          </FontWrapper>
          <ToolTipWrapper
            styles={`>p { font-weight: 400; ${
              isMobile()
                ? 'margin-top: 0px; font-size: 12px; line-height: 16px'
                : 'margin-top: 12px; font-size: 16px; line-height: 20px; letter-spacing: 0.5px width: 383px'
            }}
                      >p >span { width: ${isMobile() ? '100%' : '400px'}`}
          >
            <TrailingTooltip
              hideHeader="true"
              tooltipSize="medium"
              className="margin10 onlyLeftMargin inverse"
              tooltipContent={landline?.address_confirmation_tooltip}
              ariaLabel="Confirm your address for emergency response more information"
              typographyColor="#6F7171"
            >
              {landline && landline.legal_text}
            </TrailingTooltip>
          </ToolTipWrapper>
          <fieldset aria-label="Emergency Response Address" className="noPad noBorder">
            <Row className={type === 'mfapp' ? 'contains-PII paddTop20 leftPad5 radioPad' : 'contains-PII pad12 onlyTopPad leftPad5'} data-cs-mask>
              <VdsRadioButton
                defaultValue="none"
                analyticstrack="5G-homePhoneService-addressConfirm-radio"
                data-track={'{"type" : "input", "name" : "5G-homePhoneService-addressConfirm-radio", "state" :"$selectedAddressOption"}'.replace(
                  '$selectedAddressOption',
                  enableContinueButton ? 'checked' : 'Unchecked',
                )}
                onChange={onChangeHandler}
                onKeyPress={(e) => {
                  if (e.charCode === 13 || e.keyCode === 0) {
                    e.preventDefault();
                    onChangeHandler(e);
                  }
                }}
                data={addressArray}
              />
            </Row>
          </fieldset>
          <div className="contains-PII pad20 onlyTopPad" data-cs-mask>
            {noE911EligibleError && (
              <Notification type="warning" fullBleed={false} inline={false} disableFocus>
                <FontWrapper styles="font-size: 12px; line-height: 16px; font-weight: 400;">
                  {landline && landline.home_address_not_available_error
                    ? landline.home_address_not_available_error
                    : "The address you provided doesn't show up in the e911 database. You cannot purchase Home Phone without a confirmed address for emergency response. For more information call 866.217.2223"}
                </FontWrapper>
              </Notification>
            )}
            <div className="pad20 onlyTopPad leftPad3">
              {!noE911EligibleError && (selectedAddressOption || selectedAddress) && (
                <Checkbox
                  name="acceptSelectedAddress"
                  id="acceptSelectedAddress"
                  analyticstrack="5G-confirmHomeAddressEmergencyResponseTeamCheck"
                  data-track={'{"type" : "input", "name" : "5G-confirmHomeAddressEmergencyResponseTeamCheck", "state" :"$isChecked"}'.replace(
                    '$isChecked',
                    enableContinueButton,
                  )}
                  selected={enableContinueButton}
                  onChange={(e) => onchangeCheckBox(e)}
                  ariaLabel={landline && landline.address_confirmation_subheading}
                >
                  {landline && landline.address_confirmation_subheading}
                </Checkbox>
              )}
            </div>
          </div>

          <div className="addonBtnWrapper">
            <ModalButtonContainer className={buttonClasses}>
              <ButtonWrapper
                isDisabled={!enableContinueButton}
                buttonName="Continue"
                analyticstrack="5G-add-Phone-addressInfoView"
                data-track={enableContinueButton}
                disabled={!enableContinueButton}
                onClickContinue={onClickContinue}
                closeModal={closeModal}
              />
            </ModalButtonContainer>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

AddressConfirmationModal.propTypes = {
  selectedAddressOption: PropTypes.any,
  landline: PropTypes.object,
  closeModal: PropTypes.func,
  onClickContinue: PropTypes.func,
  propsList: PropTypes.object,
  onAddress: PropTypes.func,
  onAddressSelected: PropTypes.func,
  addressSelected: PropTypes.bool,
};

export default React.memo(AddressConfirmationModal);
